import React from 'react';
import AccountBasicInfoComponent from './add-account.components';
import TransporterLoginInfoComponent from './transporter-login-info.component';
import TransporterAccountInfoComponent from './transporter-account-info.component';
import TransporterUserProfileInfoComponent from './transporter-userProfile.component';
import TransporterMappedInfoComponent from './transporter-mapped-info.components';
import TransporterTaxInfoComponent from './transporter-tax-info.component';
import TransporterAddressComponent from './transporter-address.component';
import TabContainer from '../../../../../common/components/tab/containers/tab.containers';

export const TransporterComponent = ({ stores, agents, GSTType, GSTRegistrationType, accounts, handleBasicInnerFormChange, selectedTransporters, id, selectedAccounts, handleInnerFormChange, back, handleFormSubmit }: any) => {
    const tabItems = [
        {
            id: 1,
            title: 'Transporter-Info',
            component: (
                <AccountBasicInfoComponent
                    handleInnerFormChange={handleInnerFormChange}
                    selectedAccounts={selectedAccounts}
                />
            ),
            isVisible: id === String(0) ? true : false,
        },
        {
            id: 2,
            title: 'Basic-Info',
            component: (
                <TransporterUserProfileInfoComponent
                    onBasicInnerFormChange={handleBasicInnerFormChange}
                    onInnerFormChange={handleInnerFormChange}
                    selectedTransporters={selectedTransporters}
                />
            ),
            isVisible: id > 0 ? true : false
        },
        {
            id: 3,
            title: 'Login-Info',
            component: (
                <TransporterLoginInfoComponent
                    onInnerFormChange={handleInnerFormChange}
                    selectedTransporters={selectedTransporters}
                />
            ),
            isVisible: id > 0 ? true : false
        },
        {
            id: 4,
            title: 'Account-Info',
            component: (
                <TransporterAccountInfoComponent
                    accounts={accounts}
                    stores={stores}
                    onInnerFormChange={handleInnerFormChange}
                    selectedTransporters={selectedTransporters}
                />
            ),
            isVisible: id > 0 ? true : false
        },
        {
            id: 5,
            title: 'Mapped-Info',
            component: (
                <TransporterMappedInfoComponent
                    agents={agents}
                    selectedTransporters={selectedTransporters}
                    onInnerFormChange={handleInnerFormChange}
                />
            ),
            isVisible: id > 0 ? true : false
        },
        {
            id: 6,
            title: 'Tax-Info',
            component: (
                <TransporterTaxInfoComponent
                    GSTRegistrationType={GSTRegistrationType}
                    GSTType={GSTType}
                    onInnerFormChange={handleInnerFormChange}
                    selectedTransporters={selectedTransporters}
                />
            ),
            isVisible: id > 0 ? true : false
        },
        {
            id: 6,
            title: 'Address-Info',
            component: (
                <TransporterAddressComponent
                    handleInnerFormChange={handleInnerFormChange}
                    selectedTransporters={selectedTransporters}
                />
            ),
            isVisible: id > 0 ? true : false
        },

    ]

    return (
        <div className="flex flex-col items-center w-full px-5 overflow-auto h-auto pb-20">


            <TabContainer tabItems={tabItems} />

            <div className='flex w-full justify-end items-end h-20'>
                <button
                    onClick={back}
                    type='button'
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                >
                    Back
                </button>
                <button
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                    onClick={handleFormSubmit}

                    type="submit"
                >
                    Save
                </button>
            </div>
        </div>
    )
}
export default TransporterComponent;
